import { render, staticRenderFns } from "./ManageDomainGroups.vue?vue&type=template&id=64581166&scoped=true&"
import script from "./ManageDomainGroups.vue?vue&type=script&lang=js&"
export * from "./ManageDomainGroups.vue?vue&type=script&lang=js&"
import style0 from "./ManageDomainGroups.vue?vue&type=style&index=0&id=64581166&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64581166",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ccsbetaccscom/web/live/ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64581166')) {
      api.createRecord('64581166', component.options)
    } else {
      api.reload('64581166', component.options)
    }
    module.hot.accept("./ManageDomainGroups.vue?vue&type=template&id=64581166&scoped=true&", function () {
      api.rerender('64581166', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/domains/ManageDomainGroups.vue"
export default component.exports